<button
  class="dashboard-floating-button"
  [class.dashboard-floating-button-open]="showHelpMenu"
  type="button"
  aria-label="Ação do dashboard"
  [attr.aria-expanded]="showHelpMenu"
  (click)="openHelp()"
  (mouseenter)="closeConfirmationOnFloatingButtonHover()"
>
  <mat-icon aria-hidden="true">help_outline</mat-icon>
</button>

<div
  class="dashboard-floating-button-container"
  *ngIf="showHelpMenu"
  [class.dashboard-floating-button-container-closing]="helpMenuClosing"
  role="dialog"
  aria-label="Opções de ajuda"
>
  <button
    type="button"
    role="menuitem"
    aria-label="Contate-nos no WhatsApp"
    (click)="whatsapp()"
  >
    <img
      class="dashboard-help-whatsapp-icon"
      src="/assets/whatsapp.svg"
      alt=""
      aria-hidden="true"
    />
    <span>Contate-nos no WhatsApp</span>
  </button>
  <button
    *ngIf="
      showAuthenticatedActions ||
      sendProblemReportViaWhatsapp ||
      showProblemReportAction
    "
    type="button"
    role="menuitem"
    aria-label="Relatar um Problema"
    (click)="openProblemReport()"
  >
    <mat-icon aria-hidden="true">feedback</mat-icon>
    <span>Relatar um Problema</span>
  </button>
  <button
    *ngIf="showAuthenticatedActions"
    type="button"
    role="menuitem"
    aria-label="Dar feedback"
    [attr.aria-expanded]="showFeedback"
    (click)="openFeedback()"
  >
    <mat-icon aria-hidden="true">star</mat-icon>
    <span>Dar feedback</span>
  </button>
</div>

<div
  class="dashboard-feedback-backdrop"
  *ngIf="showProblemReport"
  [class.dashboard-feedback-backdrop-closing]="problemReportClosing"
  (click)="closeProblemReport()"
>
  <section
    class="dashboard-feedback-container dashboard-problem-report-container"
    [class.dashboard-feedback-container-closing]="problemReportClosing"
    role="dialog"
    aria-modal="true"
    aria-labelledby="dashboard-problem-report-title"
    (click)="$event.stopPropagation()"
  >
    <div class="dashboard-feedback-header">
      <div>
        <span class="dashboard-feedback-icon dashboard-problem-report-icon">
          <mat-icon aria-hidden="true">feedback</mat-icon>
        </span>
        <h2 id="dashboard-problem-report-title">Relatar um Problema</h2>
      </div>
      <button
        class="dashboard-feedback-close"
        type="button"
        aria-label="Fechar relato de Problema"
        (click)="closeProblemReport()"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>

    <p class="dashboard-feedback-description">
      Descreva o que aconteceu para ajudarmos a resolver.
    </p>

    <label class="dashboard-feedback-label" for="dashboard-problem-urgency">
      Nível de urgência do Problema
    </label>
    <select
      id="dashboard-problem-urgency"
      class="dashboard-feedback-select"
      aria-label="Nível de urgência do Problema"
      [(ngModel)]="problemUrgency"
    >
      <option value="" disabled>Selecione a urgência</option>
      <option value="low">Baixa</option>
      <option value="medium">Média</option>
      <option value="high">Alta</option>
    </select>

    <textarea
      class="dashboard-feedback-input"
      rows="5"
      placeholder="Descreva o Problema"
      autocomplete="off"
      aria-label="Descrição do Problema"
      [(ngModel)]="problemDescription"
    ></textarea>

    <div class="dashboard-feedback-actions">
      <button
        type="button"
        [disabled]="sendingProblemReport"
        (click)="closeProblemReport()"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="dashboard-feedback-submit"
        [disabled]="
          !problemDescription.trim() || !problemUrgency || sendingProblemReport
        "
        (click)="submitProblemReport()"
      >
        {{ sendingProblemReport ? "Enviando..." : "Enviar" }}
      </button>
    </div>
  </section>
</div>

<section
  *ngIf="showProblemReportConfirmation"
  class="dashboard-problem-confirmation-popover"
  [class.dashboard-problem-confirmation-popover-closing]="confirmationClosing"
  role="status"
  aria-labelledby="dashboard-problem-confirmation-title"
>
  <h2 id="dashboard-problem-confirmation-title">Obrigado!</h2>
  <p class="dashboard-problem-confirmation-text">
    Sua opinião nos ajuda muito a melhorar nossos serviços no Antecipagov.
  </p>
</section>

<div
  class="dashboard-feedback-backdrop"
  *ngIf="showFeedback"
  [class.dashboard-feedback-backdrop-closing]="feedbackClosing"
  (click)="closeFeedback()"
>
  <section
    class="dashboard-feedback-container"
    [class.dashboard-feedback-container-closing]="feedbackClosing"
    role="dialog"
    aria-modal="true"
    aria-labelledby="dashboard-feedback-title"
    (click)="$event.stopPropagation()"
  >
    <div class="dashboard-feedback-header">
      <div>
        <span class="dashboard-feedback-icon">
          <mat-icon aria-hidden="true">star</mat-icon>
        </span>
        <h2 id="dashboard-feedback-title">Dar feedback</h2>
      </div>
      <button
        class="dashboard-feedback-close"
        type="button"
        aria-label="Fechar feedback"
        (click)="closeFeedback()"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
    <div class="dashboard-feedback-prompt">Deixe sua avaliação:</div>
    <div
      class="dashboard-feedback-rating"
      [class.dashboard-feedback-rating-complete]="rating === 5"
      role="radiogroup"
      aria-label="Avaliação de uma a cinco estrelas"
      aria-required="true"
    >
      <button
        *ngFor="let star of [1, 2, 3, 4, 5]"
        type="button"
        role="radio"
        [attr.aria-label]="star + ' estrela' + (star > 1 ? 's' : '')"
        [attr.aria-checked]="rating === star"
        (click)="selectRating(star)"
      >
        <mat-icon
          [class.star-full]="getStarState(star) === 'full'"
          [class.star-empty]="getStarState(star) === 'empty'"
          >star</mat-icon
        >
      </button>
    </div>

    <p class="dashboard-feedback-description">
      Conte para nós como podemos melhorar sua experiência.
    </p>

    <textarea
      class="dashboard-feedback-input"
      rows="4"
      placeholder="Escreva seu feedback (opcional)"
      aria-label="Seu feedback (opcional)"
      [(ngModel)]="feedbackComment"
    ></textarea>

    <div class="dashboard-feedback-actions">
      <button
        type="button"
        [disabled]="sendingFeedback"
        (click)="closeFeedback()"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="dashboard-feedback-submit"
        [disabled]="rating < 1 || sendingFeedback"
        (click)="submitFeedback()"
      >
        {{ sendingFeedback ? "Enviando..." : "Enviar" }}
      </button>
    </div>
  </section>
</div>
